<template>
  <div>
    <h2 class="mt-4">Reset password</h2>

    <transition-group name="slide" mode="out-in">
      <div key="success">
        <!--<transition name="fade">-->
          <div class="alert alert-success" v-if="success">
            Email with password reset link was send to your email
          </div>
        <!--</transition>-->
      </div>

      <div key="errors">
        <!--<transition name="fade">-->
          <div class="alert alert-danger" v-if="errors">
            Something went wrong. Check your email and try again
          </div>
        <!--</transition>-->
      </div>

      <form class="mt-3" @submit.prevent="onSubmit" key="form">
        <div class="form-group" :class="{invalid: $v.email.$error}">
          <label for="email">Email</label>
          <input type="email"
                 class="form-control"
                 id="email"
                 @blur="$v.email.$touch()"
                 v-model="email">
        </div>

        <button type="submit" class="btn btn-dark" :disabled="$v.$invalid">Send request</button>
      </form>
    </transition-group>
  </div>
</template>

<script>
  import { required, email } from 'vuelidate/lib/validators'
  import axios from 'axios'

  export default {
    data() {
      return {
        email: '',
        success: false,
        errors: false
      }
    },

    validations: {
      email: {
        required,
        email
      }
    },

    methods: {
      onSubmit() {
        axios.post('/reset-password/send-email', {
          email: this.email
        })
          .then(res => {
            this.success = true
            this.errors = false

            this.email = ''
          })
          .catch(error => {
            this.errors = true
            this.success = false
          })
      }
    }
  }
</script>

<style scoped>
  .fade-enter-active {
    transition: opacity 0.5s;
  }

  .fade-leave-active {
    transition: opacity 0.5s;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/auth/ResetPasswordRequestPage.vue